import React, { FunctionComponent } from "react";

import { Helmet } from "react-helmet";

import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";

import getOpco from "utils/getOpco";
import { getPartnerImageUrl } from "utils/getImageUrl";
import { configState } from "state/config-slice";

import { API_URL } from "config";

const lang = getOpco();

const SEO: FunctionComponent = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const { cdnUrl } = useSelector(configState);
  const [searchParams] = useSearchParams();
  const possiblePartner = searchParams.get("partner") || cookies.PARTNER;
  const OpcolessCdnUrl = cdnUrl.replace(`/${getOpco()}/`, "/");

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{t("Vodafone Subscription+")}</title>
      <meta
        name="description"
        content={
          possiblePartner
            ? t("Subscribe to {{ partner }} through ", { partner: possiblePartner }) + t("Vodafone Subscription+") + "!"
            : t("Welcome to ") + t("Vodafone Subscription+") + "!"
        }
      />
      <link rel="preload" as="image" href={getPartnerImageUrl("generic/banner-desktop.webp", OpcolessCdnUrl)} />
      <link rel="preload" as="image" href={getPartnerImageUrl("generic/banner-tablet.webp", OpcolessCdnUrl)} />
      <link rel="preload" as="image" href={getPartnerImageUrl("generic/banner-mobile.webp", OpcolessCdnUrl)} />
      <link rel="preconnect" href={API_URL} />
      <link rel="preconnect" href={OpcolessCdnUrl} />
    </Helmet>
  );
};

export default React.memo(SEO);
